package com.islamicmedia.shared.domain.model

enum class MediaType(
    val label: String,
    val singularLabel: String,
    val emoji: String,
    val activeColorHex: Long
) {
    MOVIES("Movies", "Movie", "🎬", 0xFFE11D48),
    TV_SHOWS("TV Shows", "TV Show", "📺", 0xFF9333EA),
    GAMES("Video Games", "Video Game", "🎮", 0xFF2563EB),
    YOUTUBE("YouTube Channels", "YouTube Channel", "📹", 0xFFDC2626),
    BOOKS("Books", "Book", "📚", 0xFFD97706)
}
